export enum PipelineEvent {
    END_REFRESH_DATA = 'pipeline:endRefreshData',
}

export interface PipelineEventMap {
    [PipelineEvent.END_REFRESH_DATA]: void;
}
